import { ServiceCode } from '../enums/serviceCode';

export function serviceUsesBioGraders(serviceCode: ServiceCode) {
    switch (serviceCode) {
        case ServiceCode.TPO:
        case ServiceCode.TIECG:
        case ServiceCode.TCOR:
        case ServiceCode.OSASO:
        case ServiceCode.OSASVO:
        case ServiceCode.OSASQ:
        case ServiceCode.TFO:
        case ServiceCode.TOO:
        case ServiceCode.PILOT:
        case ServiceCode.OrthO:
        case ServiceCode.OrthOFol:
        case ServiceCode.OORK:
            return true;
        case ServiceCode.TPC:
        case ServiceCode.TCOH:
        case ServiceCode.TCCr:
        case ServiceCode.TCCh:
        case ServiceCode.TCCi:
        case ServiceCode.OSASV:
        case ServiceCode.OSASC1:
        case ServiceCode.OSASC2:
        case ServiceCode.GGZCg:
        case ServiceCode.GGZCt:
        case ServiceCode.GGZCf2f:
        case ServiceCode.GGZCmdo:
        case ServiceCode.GGZv:
        case ServiceCode.GGZOint:
        case ServiceCode.GGZOembl:
        case ServiceCode.GGZBther:
        case ServiceCode.TFC:
        case ServiceCode.TOC:
            return false;
        default:
            return false;
    }
}
